import { globalNotificationStore } from '@intelliarts/ia-react-template';

/**
 * Rest store mutation actions never reject: the template catches request failures, records them in
 * the global notification store under the request's root path (the URL with a trailing entity id
 * stripped, i.e. the store's `resourcePath`), and resolves anyway. The error for that path is
 * cleared when a request starts, so right after `await`-ing a mutation its presence means that
 * mutation failed. This lets submit handlers close their dialog directly after a successful await
 * instead of watching the store's changes log.
 */
export const createMutationFailedCheck = (resourcePath: string) => (): boolean =>
  Boolean(globalNotificationStore.storeState.getState().errors?.[resourcePath]);
